import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ConfigService } from '@app/core/config.service';
import { HttpClient } from '@angular/common/http';
import { ENDPOINTS } from '@app/app.constants';
import { ResourceBundleService } from '@app/services/resource-bundle/resource-bundle.service';
import { LocaleService } from '@app/services/locale/locale.service';
import { get, debounce } from 'lodash';
@Component({
    selector: 'pixie-homepage',
    templateUrl: './homepage.component.html',
    styleUrls: ['./homepage.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class HomepageComponent implements OnInit {
    siteId;
    utilsConfig;
    hkdlResourceBundle;
    parkHoursBundle;

    constructor(
        private configService: ConfigService,
        private httpClient: HttpClient,
        private resourceBundleService: ResourceBundleService,
        private localeService: LocaleService,
    ) { }

    ngOnInit() {
        this.siteId = this.configService.getValue('siteId');

        this.initHkdlQuickQuoteConfig();
        this.initHkdlQuickQuoteContent();
        this.initParkHours();
        this.orderElements();

        window.addEventListener('resize', debounce(() => {
            this.orderElements();
        }, 100));
    }

    /** Places elements in the correct order in the DOM so that keyboard navigation order matches */
    orderElements = () => {
        const homepageTop = document.getElementById('homepage-top');
        const qqContainer = document.getElementById('quick-quote-container');
        const pixieHero = document.getElementsByTagName('app-non-fast-hero')[0];
        const windowSize = window.innerWidth;
        // Desktop size (tablet size in HKDL QQ)
        // TODO: Change HKDL QQ to 1024 for consistency
        // https://github.disney.com/wdprd-development/wdpr-hkdl-quickquote/blob/develop/projects/hkdl-quickquote/src/styles/mixins.scss
        if (windowSize >= 1025) {
            homepageTop.prepend(qqContainer);
        } else { // Mobile size
            homepageTop.prepend(pixieHero);
        }
    }

    /**
     * Make call to utils and d-scribe to get the configs and contents for HKDL QQ
     */
    public initHkdlQuickQuoteConfig(): void {
        this.localeService.getLocale().then((locale: string) => {
            locale = locale || 'en';
            const localePrefix = {
                'en': 'en_US',
                'en_US': 'en_US',
                'zh_HK':  'zh-hk',
                'zh_CN': 'zh-cn',
                'ja_JP': 'ja',
                'ko_KR': 'ko',
                'th_TH': 'th',
                'id_ID': 'id',
                'ms_MY': 'ms'
              };
            locale = localePrefix[locale] || locale;
            locale = (locale === 'en_US') ? '' : ('/' + locale);
            this.httpClient.get(
                `${locale}${ENDPOINTS.utilsConfig}`
            ).subscribe((config) => {
                this.utilsConfig = config;
            });
        });
    }

    /**
     * Get the content from d-scribe call
     */
    public initHkdlQuickQuoteContent(): void {
        this.resourceBundleService.get('quickquote').then((resourceBundle) => {
            this.hkdlResourceBundle = resourceBundle;
        });
    }

    public initParkHours(): void {
        this.resourceBundleService.get('parkHours').then((resourceBundle) => {
            const val = get(resourceBundle, 'modules[1].descriptions[0].webLinks[0]', null);
            this.parkHoursBundle = val;
        });
    }
}
